import { render, staticRenderFns } from "./BundleImportDlg.vue?vue&type=template&id=4076d012&scoped=true&"
import script from "./BundleImportDlg.vue?vue&type=script&lang=ts&"
export * from "./BundleImportDlg.vue?vue&type=script&lang=ts&"
import style0 from "./BundleImportDlg.vue?vue&type=style&index=0&id=4076d012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4076d012",
  null
  
)

export default component.exports